/** 多平台发布指引（离线助手，非 API 代发） */
export const PUBLISH_PLATFORMS = [
  {
    id: 'douyin',
    name: '抖音',
    ratio: '9:16 竖屏',
    coverSize: '1080×1920 JPG',
    durationHint: '建议 15s～3min，常见 30～180s',
    portalUrl: 'https://creator.douyin.com/',
    portalLabel: '抖音创作者中心',
  },
  {
    id: 'kuaishou',
    name: '快手',
    ratio: '9:16 竖屏',
    coverSize: '竖屏封面 JPG',
    durationHint: '建议 15s～3min',
    portalUrl: 'https://cp.kuaishou.com/',
    portalLabel: '快手创作者中心',
  },
  {
    id: 'xiaohongshu',
    name: '小红书',
    ratio: '3:4 / 9:16 均可',
    coverSize: '竖屏封面 JPG',
    durationHint: '视频笔记建议 15s～5min',
    portalUrl: 'https://creator.xiaohongshu.com/',
    portalLabel: '小红书创作服务平台',
  },
  {
    id: 'bilibili',
    name: '哔哩哔哩',
    ratio: '16:9 或竖屏均可',
    coverSize: '封面 JPG/PNG',
    durationHint: '短视频与长视频均可，注意选分区',
    portalUrl: 'https://member.bilibili.com/platform/upload/video/frame',
    portalLabel: 'B 站投稿页',
  },
];

export const PUBLISH_DESCRIPTION_HINT = '支持占位符：{title} 标题、{index} 集数、{series} 系列名';

export const MOBILE_TRANSFER_TIP = '将发布包 ZIP 解压后，可通过微信「文件传输助手」或数据线传到手机相册，再在各平台 App 上传。';
